module.exports = __webpack_public_path__ + "static/media/FuturaStd-Bold.8ebc39b8.svg";